export default {
      id: "icon-veggie-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "icons.svg#icon-veggie",
      toString: function () {
        return this.url;
      }
    }